/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ProductImportStatus = typeof ProductImportStatus[keyof typeof ProductImportStatus];


export const ProductImportStatus = {
  imported: 'imported',
  fused: 'fused',
  already_imported: 'already_imported',
  publication_imported_product_missing: 'publication_imported_product_missing',
  product_dropped: 'product_dropped',
  blocked: 'blocked',
  skipped: 'skipped',
  failed: 'failed',
  unknown_product: 'unknown_product',
} as const;
